const fadeIn = {
  fromStyle: { opacity: 0, transform: 'translateX(-200%) scale(0.5)' },
  toStyle: { opacity: 0.85, transform: 'translateX(-50%) scale(1)' },
  easing: 'easeOutBack'
};

const fadeOut = {
  fromStyle: { opacity: 0.85, transform: 'translateX(-50%) scale(1)' },
  toStyle: { opacity: 0, transform: 'translateX(200%) scale(0.5)' },
  easing: 'easeOutBack'
}


export default [
  {
    text: {
		'en': "Holly is an independent author and publisher living in Genessee County, right outside of Flint, Michigan.",
		'es': "Holly es una autora y editora independiente que vive en el condado de Genesee, en las afueras de Flint, Michigan"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
    parallaxData: {
      start: 600,
      end: 700,
      ...fadeOut
    }
  },
  {
    text: {
		'en': "Holly writes a variety of young adult, or YA fantasy. Her passion is to write stories where characters facing dire circumstances can rise up and fight back against their oppressors.",
		'es': "Holly escribe una variedad de fantasía para adultos jóvenes o jóvenes adultos. Su pasión es escribir historias en las que los personajes que se enfrentan a circunstancias terribles puedan levantarse y luchar contra sus opresores"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
    parallaxData: [
      {
        start: 700,
        end: 800,
        ...fadeIn
      },
      {
        start: 2000,
        end: 2100,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "Although Holly's books may take place in fantasical lands or worlds unlike our own, never did she think that her writings would ever mirror her reality.",
		'es': "Aunque los libros de Holly pueden tener lugar en tierras o mundos fantásticos diferentes al nuestro, nunca pensó que sus escritos reflejarían su realidad"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
    parallaxData: [
      {
        start: 2100,
        end: 2200,
        ...fadeIn
      },
      {
        start: 2900,
        end: 3000,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "In the spring of 2014, Holly moves into Swartz Creek Estates -- a manufactured housing community -- Like in most manufactured home communities, she can own her home, while renting the lot.",
		'es': "En la primavera de 2014, Holly se muda a Swartz Creek Estates, una comunidad de viviendas prefabricadas. Como en la mayoría de las comunidades de viviendas prefabricadas, puede ser propietaria de su casa, mientras alquila el lote"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
    parallaxData: [
      {
        start: 3000,
        end: 3100,
        ...fadeIn
      },
      {
        start: 4000,
        end: 4100,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "The lot rent is affordable, and in just a little over 5 years, she could pay off her home entirely, allowing Holly to pursue her dream of becoming a full-time writer.",
		'es': "El alquiler del lote es asequible y, en poco más de 5 años, podría pagar su casa por completo, lo que le permitiría a Holly perseguir su sueño de convertirse en escritora a tiempo completo"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
    parallaxData: [
      {
        start: 4100,
        end: 4200,
        ...fadeIn
      },
      {
        start: 5300,
        end: 5400,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "Feeling like her life and career are finally in her own hands, Holly settles into Swartz Creek; surrounded by family, friends, and her beloved pets.",
		'es': "Sintiendo que su vida y su carrera finalmente están en sus propias manos, Holly se instala en Swartz Creek, rodeada de familiares, amigos y sus queridas mascotas"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
    parallaxData: [
      {
        start: 5400,
        end: 5500,
        ...fadeIn
      },
      {
        start: 8400,
        end: 8500,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "Unbeknownst to the community, Swartz Creek has been bought out by Havenpark Communities, a private investment firm based in Utah.",
		'es': "Sin el conocimiento de la comunidad, Havenpark Communities, una firma de inversión privada con sede en Utah, compró Swartz Creek"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
    parallaxData: [
      {
        start: 8500,
        end: 8600,
        ...fadeIn
      },
      {
        start: 9500,
        end: 9600,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "In the summer of 2019, upon returning home from a writer's retreat, Holly finds a letter on her door that states that Swartz Creek has been bought and her rent is going up by $70 -- a nearly 25% increase -- in 30 days.",
		'es': "En el verano de 2019, al regresar a casa de un retiro de escritores, Holly encuentra una carta en su puerta que dice que Swartz Creek ha sido comprado y que su alquiler aumentará $70, un aumento de casi el 25 %, en 30 días."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
    parallaxData: [
      {
        start: 9600,
        end: 9700,
        ...fadeIn
      },
      {
        start: 11700,
        end: 11800,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "Holly discovers that most of her neighbors in Swartz Creek are now facing steep rent increases, with many residents finding themselves priced out of their own homes.",
		'es': "Holly descubre que la mayoría de sus vecinos en Swartz Creek ahora enfrentan fuertes aumentos de alquiler, y muchos residentes se ven obligados a quedarse sin sus propios hogares"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
    parallaxData: [
      {
        start: 11800,
        end: 11900,
        ...fadeIn
      },
      {
        start: 14300,
        end: 14400,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "That same summer, Holly decides to take a stand. She forms 'Michigan Mobile Home Residents for Affordable Housing', an online community group where impacted residents could share stories and strategize against Havenpark's predatory tactics.",
		'es': "Holly decide luchar. Forma 'Michigan Mobile Home Residents for Affordable Housing', un grupo comunitario en línea donde los residentes afectados pueden compartir historias y crear estrategias contra las tácticas depredadoras de Havenpark"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/C.png',
    parallaxData: [
      {
        start: 14400,
        end: 14500,
        ...fadeIn
      },
      {
        start: 15600,
        end: 15700,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "Through shared experiences and personal research, Holly and her neighbors realize that Havenpark is buying communities all over Michigan; not just pricing people out of their homes in Genessee County, but also across the state...and there is little the law can do to protect residents.",
		'es': "A través de experiencias compartidas e investigación personal, Holly y sus vecinos se dan cuenta de que Havenpark está comprando comunidades en todo Michigan, no solo sacando a las personas de sus hogares en el condado de Genessee, sino también en todo el estado... y es poco lo que la ley puede hacer para proteger a los residentes"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/C.png',
    parallaxData: [
      {
        start: 15700,
        end: 15800,
        ...fadeIn
      },
      {
        start: 18100,
        end: 18200,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "Holly reaches out to MHAction, an organization dedicated to advocating for better policies and protections for manufactured home residents.",
		'es': "Holly se acerca a MHAction, una organización dedicada a abogar por mejores políticas y protecciones para los residentes de casas prefabricadas"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/C.png',
    parallaxData: [
      {
        start: 18200,
        end: 18300,
        ...fadeIn
      },
      {
        start: 19000,
        end: 19100,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "With the help of MHAction, Holly and her neighbors find out Havenpark is financed by Fannie Mae and Freddie Mac via Bellweather Entreprise, a subsidiary of Enterprise Community Partners, a non-profit dedicated to increasing and preserving affordable housing across the country.",
		'es': "Con la ayuda de MHAction, Holly y sus vecinos descubren que Havenpark está financiado por Fannie Mae y Freddie Mac a través de Bellweather Entreprise, una subsidiaria de Enterprise Community Partners, una organización sin fines de lucro dedicada a aumentar y preservar viviendas asequibles en todo el país"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/D.png',
    parallaxData: [
      {
        start: 19100,
        end: 19200,
        ...fadeIn
      },
      {
        start: 20400,
        end: 20500,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "To their shock, the very institutions meant to protect affordable housing are funding companies doing their best to endanger it; revealing a larger, national scheme to increase rents in low-income communities across the country.",
		'es': "Para su sorpresa, las mismas instituciones destinadas a proteger las viviendas asequibles están financiando a las empresas que hacen todo lo posible para ponerlas en peligro, revelando un plan nacional más amplio para aumentar los alquileres en comunidades de bajos ingresos en todo el país"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/D.png',
    parallaxData: [
      {
        start: 20500,
        end: 20600,
        ...fadeIn
      },
      {
        start: 21900,
        end: 22000,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "Incensed, Holly and neighbors build a campaign driven by residents of Havenpark-owned communities in Michigan, Iowa, Montana, and North Dakota.",
		'es': "Indignados, Holly y los vecinos crean una campaña impulsada por los residentes de las comunidades propiedad de Havenpark en Michigan, Iowa, Montana y Dakota del Norte"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/D.png',
    parallaxData: [
      {
        start: 22000,
        end: 22100,
        ...fadeIn
      },
      {
        start: 23200,
        end: 23300,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "In December of 2019, Holly flies to Washington D.C. along with other residents and MHAction representatives to speak out against Havenpark at a Fannie Mae hearing attended by politicians, policy makers, and financiers alike.",
		'es': "En diciembre de 2019, Holly vuela a Washington D.C. junto con otros residentes y representantes de MHAction para hablar en contra de Havenpark en una audiencia de Fannie Mae a la que asistieron políticos, legisladores y financieros por igual"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/D.png',
    parallaxData: [
      {
        start: 23300,
        end: 23400,
        ...fadeIn
      },
      {
        start: 24400,
        end: 24500,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "They make a direct call to action against funding predatory developers and investment firms, as well as demanding regulation and oversight. To date, the Federal Housing Finance Agency (FHFA) has introduced slight protections on behalf of residents, but Holly recognizes there is still work to be done.",
		'es': "Hacen un llamado directo a la acción contra la financiación de empresas de inversión y desarrolladores depredadores, así como también exigen regulación y supervisión. Hasta la fecha, la Agencia Federal de Financiamiento de la Vivienda (FHFA, por sus siglas en inglés) ha introducido ligeras protecciones en nombre de los residentes, pero Holly reconoce que todavía hay trabajo por hacer"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/D.png',
    parallaxData: [
      {
        start: 24500,
        end: 24600,
        ...fadeIn
      },
      {
        start: 25500,
        end: 25600,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "Holly's story isn't over. While she and other MHAction leaders continue to fight for resident protections, Holly was recently appointed to the Michigan Manufactured Housing Commission in 2022. Similar to her fantasy novels, Holly hopes her story can empower others to rise up against wrongdoing.",
		'es': "La historia de Holly no ha terminado. Mientras ella y otros líderes de MHAction continúan luchando por la protección de los residentes, Holly fue nombrada recientemente para la Comisión de Viviendas Prefabricadas de Michigan en 2022. Al igual que sus novelas de fantasía, Holly espera que su historia pueda empoderar a otros para que se levanten contra el mal"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/E.png',
    parallaxData: [
      {
        start: 25600,
        end: 25700,
        ...fadeIn
      }
    ]
  }
];
